import { moduleProviderFactory } from "core/providers";
import { FacilityOrderNewFlowBillingPreview } from "application/facility-order-new-flow-billing/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.facility-order",
				pattern: "/facility-orders",
                children: [
					{
						name: "master.app.main.facility-order.facility-order-new-flow.billing.preview",
						pattern: "/:id/new-flow/billing",
						authorization: "facilityOrderSection.update",
						component: FacilityOrderNewFlowBillingPreview,
						data: {
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.BILLING",
									route: 'master.app.main.facility-order.facility-order-new-flow.billing-preview'
								}
							],
							back: "master.app.main.facility-order.facility-order-new-flow.list",
						},
					}
                ]
            }
        ],
		menu: [
            {
				title: "MENU.FACILITY_ORDERS",
				icon: "package",
				authorization: "coreUserSection.read",
				order: 5,
				subMenu: [
					{
						title: "MENU.FACILITY_ORDERS_SUB",
						authorization: "facilityOrderSection.read",
						route: "master.app.main.facility-order.facility-order-new-flow.list",
						order: 2,
					}
				]
			},
        ]
    });
})();
